
import { Component, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";
import DateHelper from "@/utils/DateHelper";
import { GameHistory, Meta } from "@/models/GameHistory";

@Component
class GamesTableHistory extends Vue {
  periodSelected = -1;
  yearSelected = this.years[this.years.length - 1];
  searchFilter = "";
  busy = true;
  date = { endDate: "", startDate: "" };
  get years(): number[] {
    const year = new Date().getFullYear();
    return Array.from({ length: year - 2018 }, (value, index) => 2019 + index);
  }

  get isLoading(): boolean {
    return this.$store.state.gameStore.loading;
  }
  get gameHistoryArray(): GameHistory[] {
    return this.$store.state.gameStore.historyGames.filter((items: Meta) => {
      return (
        new Date(items.start_dt) >= new Date(this.date.startDate) &&
        new Date(items.start_dt) <= new Date(this.date.endDate)
      );
    });
  }

  get getPreAppLaunch(): number {
    return this.$store.state.authenication.appPrelaunch._value;
  }

  getHistory(): void {
    this.$store.commit("gameStore/historyGame", []);
    this.$store.dispatch("gameStore/getHistoryGames");
    this.updateDates();
  }
  onRowSelected(rows: any): void {
    if (rows.length < 1) return;
    this.$emit("handleGameSelection", rows[0]);
  }
  filterByAdminName(row: any): boolean {
    if (
      row.admin_name.toLowerCase().includes(this.searchFilter.toLowerCase())
    ) {
      return true;
    }
    return false;
  }
  updateDates(): void {
    if (this.periodSelected !== -1) {
      this.date = {
        endDate: new Date(
          this.yearSelected,
          this.periodSelected + 1,
          0,
          23,
          59,
          59
        ).toString(),
        startDate: new Date(
          this.yearSelected,
          this.periodSelected,
          1
        ).toString(),
      };
    } else {
      this.date = {
        endDate: DateHelper.getDatesInUTC(0),
        startDate: DateHelper.getDatesInUTC(30),
      };
    }
  }

  months = [
    { value: 0, text: "January" },
    { value: 1, text: "February" },
    { value: 2, text: "March" },
    { value: 3, text: "April" },
    { value: 4, text: "May" },
    { value: 5, text: "June" },
    { value: 6, text: "July" },
    { value: 7, text: "August" },
    { value: 8, text: "September" },
    { value: 9, text: "October" },
    { value: 10, text: "November" },
    { value: 11, text: "December" },
    { value: -1, text: "Last 30 Days" },
  ];
  //Fields needed for table
  fields = [
    {
      key: "admin_name",
      label: "Name",
      sortable: true,
    },

    {
      key: "start_dt",
      label: "Start",
      sortByFormatted: true,
      sortable: true,
      formatter: (value: string) => {
        // * Get the time in a readable format

        return DateTime.fromISO(value).toFormat("D TTT");
      },
    },
    {
      key: "season.gt_dname.en",
      label: "Game",
      sortable: true,
    },
    {
      key: "season.seas_dname.en",
      label: "Season",
      sortable: true,
    },
  ];
}
export default GamesTableHistory;
